export interface HelpItem {
  id: string;
  path: string;
  title: string;
  shortDesc: string;
  fullDesc: string;
  features: string[];
  tips?: string[];
  planRequired?: string;
}

export interface HelpCategory {
  title: string;
  items: HelpItem[];
}

export const helpSections: HelpItem[] = [
  // ── Быстрый старт ──
  {
    id: 'quick-start-overview',
    path: '/help',
    title: 'С чего начать',
    shortDesc: 'Пошаговая инструкция по запуску вашего сервиса доставки с нуля.',
    fullDesc: 'Этот гайд проведёт вас через все этапы настройки: от создания аккаунта до приёма первых заказов. Следуйте шагам по порядку — каждый следующий опирается на предыдущий.',
    features: [
      'Шаг 1. Заполните «Общие настройки» — название, контакты, часы работы',
      'Шаг 2. Создайте «Категории» товаров — пицца, бургеры, напитки и т.д.',
      'Шаг 3. Добавьте «Товары» — фото, описание, цену, варианты размеров',
      'Шаг 4. Настройте «Зоны доставки» на карте — районы и стоимость',
      'Шаг 5. Подключите «Способы оплаты» — наличные, карта, онлайн',
      'Шаг 6. Проверьте сайт — откройте ваш адрес и сделайте тестовый заказ',
    ],
    tips: [
      'Начните с минимума: 3-4 категории и 10-15 товаров — расширить можно позже',
      'Не забудьте указать реальный номер телефона в настройках — клиенты будут звонить',
      'Сделайте тестовый заказ сами, чтобы проверить весь процесс от начала до конца',
    ],
  },
  {
    id: 'quick-start-telegram',
    path: '/help',
    title: 'Подключение Telegram',
    shortDesc: 'Пошаговая настройка Telegram-бота и мини-приложения для приёма заказов.',
    fullDesc: 'Telegram мини-приложение позволяет вашим клиентам заказывать еду прямо из мессенджера — без установки отдельных приложений. Вам нужно создать бота и привязать его к вашему аккаунту.',
    features: [
      'Шаг 1. Откройте Telegram и найдите @BotFather',
      'Шаг 2. Отправьте команду /newbot',
      'Шаг 3. Введите отображаемое имя бота (например: «Пицца Экспресс»)',
      'Шаг 4. Введите username бота (например: pizza_express_bot) — должен заканчиваться на _bot',
      'Шаг 5. Скопируйте токен бота — строка вида 123456789:ABCdefGHIjklMNOpqrsTUVwxyz',
      'Шаг 6. В BotFather: /mybots → выберите бота → Bot Settings → Menu Button → Configure menu button',
      'Шаг 7. Вставьте URL вашего мини-приложения (уточните у администратора платформы)',
      'Шаг 8. Введите текст кнопки: «Заказать еду»',
      'Шаг 9. Передайте токен бота и username администратору платформы для привязки к вашему аккаунту',
      'Шаг 10. Откройте бота в Telegram → нажмите кнопку «Заказать еду» → проверьте, что каталог загрузился',
    ],
    tips: [
      'Username бота нельзя изменить после создания — выбирайте осмысленное имя',
      'Токен бота — секретная информация, не публикуйте его в открытом доступе',
      'После привязки бота клиенты смогут открывать каталог, собирать корзину и оформлять заказы прямо в Telegram',
      'Кнопка меню появляется у всех пользователей в диалоге с ботом — это основная точка входа',
    ],
  },
  {
    id: 'quick-start-vk',
    path: '/help',
    title: 'Подключение ВКонтакте',
    shortDesc: 'Пошаговая настройка VK Mini App для приёма заказов из ВКонтакте.',
    fullDesc: 'VK мини-приложение позволяет клиентам заказывать еду из ВКонтакте. Нужно создать приложение на платформе VK и пройти модерацию.',
    features: [
      'Шаг 1. Перейдите на vk.com/apps?act=manage и нажмите «Создать»',
      'Шаг 2. Выберите тип «Mini App» и введите название (например: «Пицца Экспресс»)',
      'Шаг 3. Выберите категорию «Еда и напитки»',
      'Шаг 4. В настройках приложения укажите URL — его предоставит администратор платформы',
      'Шаг 5. Скопируйте ID приложения (число в URL страницы настроек)',
      'Шаг 6. Передайте ID приложения администратору платформы для привязки',
      'Шаг 7. Подготовьте материалы для модерации VK:',
      '   — Иконка 576×576 px (PNG, без скруглений)',
      '   — Иконка 150×150 px',
      '   — Скриншот работающего приложения (не менее 1080px по ширине)',
      '   — Краткое описание (до 140 символов)',
      '   — Полное описание (до 4000 символов)',
      '   — Описание 2-3 пользовательских сценариев',
      'Шаг 8. Отправьте приложение на модерацию в VK',
      'Шаг 9. После одобрения — приложение станет доступно всем пользователям VK',
    ],
    tips: [
      'Модерация VK занимает от 1 до 5 рабочих дней — подготовьте качественные скриншоты и описания',
      'Иконка должна отражать суть вашего бизнеса — используйте логотип или изображение блюда',
      'В описании сценариев подробно опишите: заказ с доставкой, самовывоз, использование акций',
      'Пока приложение на модерации, оно доступно только вам для тестирования',
    ],
  },
  {
    id: 'quick-start-first-order',
    path: '/help',
    title: 'Первый заказ и проверка',
    shortDesc: 'Чек-лист проверки перед стартом: убедитесь, что всё работает.',
    fullDesc: 'Перед тем как объявить клиентам о запуске, пройдите по чек-листу и убедитесь, что всё настроено корректно. Сделайте тестовый заказ на каждом канале.',
    features: [
      '✓ Общие настройки заполнены — название, адрес, телефон, режим работы',
      '✓ Филиал создан — указан адрес точки для самовывоза',
      '✓ Зоны доставки настроены — районы и стоимость доставки',
      '✓ Категории созданы — минимум 3-4 категории',
      '✓ Товары добавлены — минимум 10-15 позиций с фото и ценами',
      '✓ Способы оплаты настроены — наличные, карта',
      '✓ Сайт проверен — каталог загружается, заказ оформляется',
      '✓ Telegram бот проверен — мини-приложение открывается, заказ проходит',
      '✓ VK приложение проверено — каталог доступен, заказ работает',
      '✓ Тестовый заказ виден в разделе «Заказы» админ-панели',
    ],
    tips: [
      'Сделайте тестовый заказ с реального телефона — проверьте SMS/уведомления',
      'Попросите друга или коллегу сделать заказ — свежий взгляд найдёт проблемы',
      'Проверьте, как выглядит каталог на мобильном телефоне — большинство заказов идут с телефонов',
      'После тестов удалите тестовые заказы из системы',
    ],
  },

  // ── Основное ──
  {
    id: 'dashboard',
    path: '/',
    title: 'Дашборд',
    shortDesc: 'Обзор ключевых показателей вашего заведения. Заказы, выручка и статистика клиентов за сегодня и выбранный период.',
    fullDesc: 'Главная страница админ-панели показывает сводку по основным метрикам: количество заказов, общая выручка, средний чек, число новых клиентов. Данные обновляются в реальном времени и позволяют быстро оценить состояние бизнеса.',
    features: [
      'Количество заказов за сегодня и выбранный период',
      'Общая выручка и средний чек',
      'Число новых и повторных клиентов',
      'График динамики заказов',
      'Популярные товары дня',
    ],
    tips: [
      'Проверяйте дашборд в начале рабочего дня для оценки текущей ситуации',
      'Используйте фильтр по периоду для сравнения показателей',
    ],
  },
  {
    id: 'orders',
    path: '/orders',
    title: 'Заказы',
    shortDesc: 'Управление заказами: фильтрация по статусам и датам, поиск, пагинация, смена статуса. Подробная карточка каждого заказа.',
    fullDesc: 'Раздел «Заказы» — центральный инструмент для обработки входящих заказов. Здесь вы видите все заказы со всех платформ (сайт, Telegram, VK), можете фильтровать их, менять статусы, просматривать детали и печатать чеки.',
    features: [
      'Список заказов с фильтрами по статусу, дате и источнику',
      'Поиск по номеру заказа, имени или телефону клиента',
      'Смена статуса заказа (новый → в работе → доставляется → выполнен)',
      'Детальная карточка: состав, сумма, адрес, комментарий',
      'Печать чека и данных для курьера',
      'Пагинация для удобной навигации',
    ],
    tips: [
      'Настройте звуковое уведомление о новых заказах',
      'Используйте быстрые фильтры для просмотра только активных заказов',
    ],
  },
  {
    id: 'products',
    path: '/products',
    title: 'Товары',
    shortDesc: 'Каталог товаров: создание, редактирование, варианты, изображения, модификаторы. Массовые операции и копирование.',
    fullDesc: 'Управляйте ассортиментом вашего заведения. Создавайте товары с вариантами (размеры, объёмы), загружайте изображения, привязывайте модификаторы (добавки, соусы). Поддерживаются массовые операции для экономии времени.',
    features: [
      'Создание и редактирование товаров (CRUD)',
      'Варианты товара (размер, объём и т.д.) с отдельными ценами',
      'Загрузка и управление изображениями',
      'Привязка модификаторов (добавки, соусы)',
      'Копирование товара для быстрого создания похожих',
      'Массовое удаление выбранных товаров',
      'Указание веса, калорийности, описания',
      'Управление видимостью (скрыть / показать)',
    ],
    tips: [
      'Используйте копирование товара для быстрого создания вариаций',
      'Загружайте изображения в формате WebP для ускорения загрузки',
      'Привязывайте модификаторы на уровне категории, чтобы не настраивать для каждого товара',
    ],
  },
  {
    id: 'categories',
    path: '/categories',
    title: 'Категории',
    shortDesc: 'Организация каталога: категории товаров с названием, описанием, изображением и настройкой видимости.',
    fullDesc: 'Категории помогают структурировать меню. Каждая категория имеет название, slug для URL, описание, изображение и настройки видимости. Порядок отображения настраивается перетаскиванием.',
    features: [
      'Создание и редактирование категорий',
      'Slug для SEO-оптимизированных URL',
      'Описание и изображение категории',
      'Управление видимостью категории',
      'Сортировка порядка отображения',
      'Привязка модификаторов к категории (применяются ко всем товарам)',
    ],
    tips: [
      'Используйте понятные slug для улучшения SEO',
      'Скрывайте пустые категории вместо удаления',
    ],
  },
  {
    id: 'modifiers',
    path: '/modifiers',
    title: 'Модификаторы',
    shortDesc: 'Группы модификаторов и элементы: добавки, соусы, топпинги, а также выбор одного варианта (размер, тесто). Привязка к товарам и категориям.',
    fullDesc: 'Модификаторы позволяют клиентам кастомизировать заказ — добавить сыр, выбрать соус или размер. Создаются группами, внутри которых перечислены конкретные элементы с наценкой к базовой цене товара. Тип «Добавка» — мультивыбор (соусы, топпинги). Тип «Модификатор» — клиент выбирает ровно один вариант: например группа «Размер пиццы» с элементами «25 см» (наценка 0), «30 см» (+200), «35 см» (+400). Это наценка к одному товару, а не отдельные SKU: у размеров не будет своих остатков и артикулов CRM — для этого объединяйте товары в SKU.',
    features: [
      'Создание групп модификаторов (Соусы, Добавки, Размер и т.д.)',
      'Добавление элементов с названием и наценкой',
      'Сортировка элементов через drag-n-drop',
      'Привязка группы к товарам или целым категориям',
      'Настройка обязательности выбора',
      'Мин/макс количество выбираемых элементов',
    ],
    tips: [
      'Привязывайте модификаторы к категории для автоматического применения ко всем товарам в ней',
      'Используйте модификаторы с нулевой ценой для опций без доплаты',
    ],
  },
  {
    id: 'stickers',
    path: '/stickers',
    title: 'Стикеры',
    shortDesc: 'Бедж-метки на карточках товаров: «Новинка», «Хит», «Острое» и другие. Привлекают внимание клиентов.',
    fullDesc: 'Стикеры — это яркие бейджи, которые отображаются на карточках товаров в каталоге. Они помогают выделить определённые товары и привлечь внимание покупателей. Вы можете создать любые стикеры с настраиваемым текстом и цветом.',
    features: [
      'Создание стикеров с произвольным текстом',
      'Выбор цвета фона и текста',
      'Привязка стикеров к товарам',
      'Возможность назначить несколько стикеров на один товар',
    ],
    tips: [
      'Не перегружайте товар стикерами — 1-2 достаточно',
      'Используйте контрастные цвета для лучшей видимости',
    ],
  },
  {
    id: 'clients',
    path: '/clients',
    title: 'Клиенты',
    shortDesc: 'Клиентская база: список клиентов, профиль, история заказов, бонусный баланс, адреса доставки.',
    fullDesc: 'Раздел содержит полную базу ваших клиентов. Для каждого клиента доступен профиль с историей заказов, бонусным балансом, сохранёнными адресами и контактными данными.',
    features: [
      'Список клиентов с поиском и фильтрацией',
      'Профиль клиента: имя, телефон, email',
      'История заказов клиента',
      'Текущий бонусный баланс',
      'Список сохранённых адресов',
      'Ручная корректировка бонусов',
    ],
    tips: [
      'Используйте фильтрацию для поиска VIP-клиентов с большим количеством заказов',
    ],
  },

  // ── Маркетинг ──
  {
    id: 'promo-codes',
    path: '/promo-codes',
    title: 'Промокоды',
    shortDesc: 'Создание промокодов с настройкой типа и размера скидки, условий применения, лимитов использования.',
    fullDesc: 'Промокоды — классический инструмент привлечения и удержания клиентов. Настраивайте тип скидки (процент или фиксированная сумма), минимальную сумму заказа, срок действия и лимиты использования.',
    features: [
      'Генерация уникальных промокодов',
      'Тип скидки: процент или фиксированная сумма',
      'Минимальная сумма заказа для активации',
      'Лимит общего количества использований',
      'Лимит использований на одного клиента',
      'Срок действия (дата начала и окончания)',
      'Привязка к определённым товарам или категориям',
    ],
    tips: [
      'Используйте лимит на клиента = 1 для первых заказов',
      'Создавайте отдельные промокоды для разных рекламных каналов для отслеживания эффективности',
    ],
    planRequired: 'starter',
  },
  {
    id: 'auto-discounts',
    path: '/auto-discounts',
    title: 'Автоскидки',
    shortDesc: 'Автоматические скидки по условиям: сумма заказа, количество товаров, день недели, время суток.',
    fullDesc: 'Автоскидки применяются автоматически при выполнении заданных условий — без промокода. Это удобный инструмент для поощрения больших заказов, happy hours и других маркетинговых механик.',
    features: [
      'Скидка по сумме заказа (от X рублей)',
      'Скидка по количеству товаров в корзине',
      'Привязка к дням недели и времени суток',
      'Тип: процент или фиксированная сумма',
      'Приоритет при пересечении нескольких скидок',
      'Ограничение по категориям/товарам',
    ],
    tips: [
      'Настройте «happy hours» со скидкой в часы низкого спроса',
      'Комбинируйте автоскидки с порогом «до бесплатной доставки»',
    ],
    planRequired: 'starter',
  },
  {
    id: 'gift-scale',
    path: '/gift-scale',
    title: 'Шкала подарков',
    shortDesc: 'Пороговые суммы заказа для добавления бесплатных подарков. Мотивирует увеличивать средний чек.',
    fullDesc: 'Шкала подарков — инструмент повышения среднего чека. При достижении определённой суммы заказа клиент получает бесплатный подарок. Можно настроить несколько порогов для мотивации к более крупным заказам.',
    features: [
      'Настройка нескольких порогов суммы заказа',
      'Привязка товара-подарка к каждому порогу',
      'Визуальная шкала прогресса для клиента',
      'Гибкое включение/выключение',
    ],
    tips: [
      'Устанавливайте первый порог чуть выше текущего среднего чека',
      'Используйте недорогие, но приятные подарки (напиток, десерт)',
    ],
    planRequired: 'business',
  },
  {
    id: 'bonus-program',
    path: '/bonus-program',
    title: 'Бонусная программа',
    shortDesc: 'Кешбэк бонусами: процент начисления, процент оплаты, welcome-бонус, бонус в день рождения.',
    fullDesc: 'Бонусная программа позволяет начислять клиентам баллы за заказы и разрешать оплату ими части следующего заказа. Можно настроить приветственный бонус для новых клиентов и подарок ко дню рождения.',
    features: [
      'Процент начисления бонусов от суммы заказа',
      'Максимальный процент оплаты бонусами',
      'Welcome-бонус для новых клиентов',
      'Бонус в день рождения',
      'Срок сгорания бонусов',
      'Ручная корректировка баланса в карточке клиента',
    ],
    tips: [
      'Оптимальный кешбэк: 3–5% начисления, до 20% оплаты',
      'Welcome-бонус увеличивает конверсию первого заказа на 15–25%',
    ],
    planRequired: 'business',
  },
  {
    id: 'push',
    path: '/push',
    title: 'Push-рассылки',
    shortDesc: 'Push-уведомления по сегментам клиентов. Информируйте об акциях, новинках и специальных предложениях.',
    fullDesc: 'Push-рассылки позволяют отправлять уведомления клиентам, которые установили ваше приложение или подписались на уведомления в браузере. Можно таргетировать по сегментам для повышения релевантности.',
    features: [
      'Создание push-уведомления с заголовком и текстом',
      'Выбор сегмента получателей',
      'Отложенная отправка (по расписанию)',
      'Прикрепление изображения',
      'Ссылка при клике по уведомлению',
      'Статистика доставки и кликов',
    ],
    tips: [
      'Не отправляйте push чаще 2–3 раз в неделю',
      'Лучшее время для push: 11:00–13:00 и 17:00–19:00',
    ],
    planRequired: 'business',
  },
  {
    id: 'segments',
    path: '/segments',
    title: 'Сегменты',
    shortDesc: 'Сегментация клиентской базы по правилам: сумма заказов, частота, дата последнего заказа и другие критерии.',
    fullDesc: 'Сегменты позволяют делить клиентскую базу на группы по заданным правилам. Используйте сегменты для таргетированных push-рассылок и персонализированного маркетинга.',
    features: [
      'Создание сегментов по правилам (конструктор)',
      'Критерии: сумма заказов, количество заказов, давность',
      'Комбинация условий (И / ИЛИ)',
      'Автоматическое обновление состава сегмента',
      'Использование в push-рассылках',
    ],
    tips: [
      'Создайте сегмент «Ушедшие» (нет заказов 30+ дней) для win-back кампаний',
      'Сегмент «VIP» (>10 заказов) — для эксклюзивных предложений',
    ],
    planRequired: 'business',
  },
  {
    id: 'marketing-presets',
    path: '/marketing-presets',
    title: 'Маркетинговые пресеты',
    shortDesc: 'Готовые шаблоны акций: счастливые часы, скидка на первый заказ, подарок при покупке и другие.',
    fullDesc: 'Маркетинговые пресеты — это готовые шаблоны популярных акций, которые можно активировать в один клик. Не нужно настраивать с нуля — просто выберите пресет, скорректируйте параметры и запустите.',
    features: [
      'Библиотека готовых шаблонов акций',
      'Быстрая активация в один клик',
      'Настройка параметров под ваше заведение',
      'Пресеты: happy hours, скидка на первый заказ, 1+1, подарок к заказу',
    ],
    tips: [
      'Начните с пресета «Скидка на первый заказ» — он даёт максимальную конверсию',
    ],
    planRequired: 'business',
  },
  {
    id: 'marketing-tools',
    path: '/marketing-tools',
    title: 'Маркетинговые инструменты',
    shortDesc: 'Social Proof, виджеты срочности, таймеры обратного отсчёта и другие инструменты повышения конверсии.',
    fullDesc: 'Набор инструментов для повышения конверсии на сайте. Social Proof показывает уведомления о недавних заказах, таймеры создают ощущение срочности, виджеты привлекают внимание к акциям.',
    features: [
      'Social Proof: уведомления о недавних заказах/покупках',
      'Таймер обратного отсчёта для акций',
      'Виджеты «Остался N штук»',
      'Всплывающие баннеры с предложениями',
      'Настройка частоты и условий показа',
    ],
    tips: [
      'Social Proof лучше работает в часы пик — настройте расписание',
      'Не включайте все инструменты одновременно, чтобы не раздражать клиентов',
    ],
    planRequired: 'business',
  },
  {
    id: 'cart-rules',
    path: '/cart-rules',
    title: 'Правила корзины',
    shortDesc: 'Визуальный flow-editor для настройки правил корзины: автоскидки, подарки, ограничения и кросс-продажи.',
    fullDesc: 'Визуальный редактор правил позволяет создавать сложные сценарии поведения корзины без программирования. Используйте drag-n-drop для построения цепочек условий и действий.',
    features: [
      'Визуальный flow-editor с drag-n-drop',
      'Узлы условий: сумма, количество, категория, время',
      'Узлы действий: скидка, подарок, сообщение',
      'Приоритеты и комбинирование правил',
      'Предпросмотр результата',
    ],
    tips: [
      'Начните с простого правила (например, «от 1500₽ — бесплатная доставка»)',
      'Тестируйте правила перед активацией',
    ],
    planRequired: 'starter',
  },

  // ── Контент ──
  {
    id: 'promotions',
    path: '/promotions',
    title: 'Акции',
    shortDesc: 'Спецпредложения с изображениями и SEO-настройками. Публикация акций на всех платформах.',
    fullDesc: 'Создавайте страницы акций с привлекательными изображениями, подробным описанием и SEO-метаданными. Акции отображаются на сайте, в мобильном приложении и мини-приложениях.',
    features: [
      'Создание акций с заголовком и описанием',
      'Загрузка баннерного изображения',
      'SEO-поля: title, description, slug',
      'Настройка срока действия',
      'Отображение на всех платформах',
    ],
    tips: [
      'Добавляйте яркие изображения — они увеличивают CTR на 40%',
      'Заполняйте SEO-поля для лучшей индексации',
    ],
    planRequired: 'starter',
  },
  {
    id: 'banners',
    path: '/banners',
    title: 'Слайды в шапке',
    shortDesc: 'Слайды в шапке сайта: изображение, ссылка, позиция. Ротация и расписание показа.',
    fullDesc: 'Слайды размещаются в шапке главной страницы и в каталоге. Поддерживается настройка позиции, ссылки при клике, расписания показа и ротации нескольких слайдов.',
    features: [
      'Загрузка изображения слайда',
      'Ссылка при клике (внутренняя или внешняя)',
      'Выбор позиции на странице',
      'Сортировка порядка отображения',
      'Расписание показа (дата начала/окончания)',
      'Отображение на мобильных и десктопе',
    ],
    tips: [
      'Оптимальный размер слайда: 1200×400px',
      'Меняйте слайды каждые 1–2 недели для поддержания интереса',
    ],
    planRequired: 'starter',
  },
  {
    id: 'stories',
    path: '/stories',
    title: 'Сторис',
    shortDesc: 'Instagram-подобные сторис со слайдами. Привлекают внимание к акциям и новинкам на главной странице.',
    fullDesc: 'Сторис — это интерактивный формат контента, похожий на Instagram Stories. Создавайте сторис со слайдами, кнопками и ссылками для вовлечения клиентов.',
    features: [
      'Создание сторис с несколькими слайдами',
      'Изображение превью (thumbnail)',
      'Кнопка с ссылкой на каждом слайде',
      'Настройка порядка отображения',
      'Автоматическое скрытие просмотренных',
    ],
    tips: [
      'Используйте сторис для анонсов новых товаров и акций',
      'Оптимальное количество слайдов: 3–5',
    ],
    planRequired: 'starter',
  },
  {
    id: 'pages-cms',
    path: '/pages',
    title: 'Страницы (CMS)',
    shortDesc: 'Создавайте кастомные страницы сайта: «О нас», «Доставка», «Акции» и др. Каждая страница доступна по уникальному URL.',
    fullDesc: 'Модуль «Страницы» позволяет создавать произвольные информационные страницы на сайте. Каждая страница получает уникальный URL вида /page/ваш-slug и доступна всем посетителям сайта. Вы можете использовать HTML-разметку для оформления контента.',
    features: [
      'Создание страницы: нажмите «Добавить» → заполните заголовок, slug и контент → нажмите «Сохранить»',
      'Поле «URL (slug)» — короткое имя для адреса страницы, ТОЛЬКО латиница (например: about, delivery, skidka). Не вставляйте полный URL или ссылки!',
      'Готовая ссылка на страницу будет иметь вид: https://ваш-домен/page/slug (например: https://my-shop.zhorka.tech/page/skidka)',
      'Поле «Содержимое» поддерживает HTML-разметку: заголовки (<h2>), абзацы (<p>), списки (<ul><li>), ссылки (<a>), жирный (<b>) и т.д.',
      'Meta Title и Meta Description — SEO-поля для отображения в поисковых системах. Необязательно, но рекомендуется для продвижения',
      'Переключатель «Опубликована» — страница видна посетителям сайта только когда включён. Если выключен — страница существует, но не отображается',
      'Поле «Сортировка» — числовой порядок отображения страниц в списке',
    ],
    tips: [
      'В поле «URL (slug)» вводите ТОЛЬКО короткое имя латиницей: about, delivery, contacts — без слешей, пробелов и кириллицы',
      'Страница доступна в браузере по адресу: /page/ваш-slug (например, /page/about)',
      'Если страница не отображается на сайте — проверьте что переключатель «Опубликована» включён',
      'Для красивого оформления используйте HTML: <h2>Заголовок</h2>, <p>Текст</p>, <ul><li>Пункт</li></ul>',
      'Рекомендуем создать базовые страницы: «О нас» (about), «Доставка и оплата» (delivery), «Контакты» (contacts), «Политика конфиденциальности» (privacy)',
      'Ссылку на созданную страницу можно разместить в соц.сетях, Telegram, VK — она откроется в браузере',
    ],
    planRequired: 'starter',
  },
  {
    id: 'widgets',
    path: '/widgets',
    title: 'Виджеты',
    shortDesc: 'Контентные блоки с расписанием показа. Размещайте дополнительную информацию на страницах сайта.',
    fullDesc: 'Виджеты — это гибкие контентные блоки, которые можно разместить в различных зонах сайта. Поддерживается расписание показа, что позволяет автоматизировать ротацию контента.',
    features: [
      'Создание контентных блоков с HTML/Markdown',
      'Выбор зоны размещения на сайте',
      'Расписание показа (дни недели, время)',
      'Приоритет отображения',
      'Предпросмотр виджета',
    ],
    tips: [
      'Используйте виджеты для информации о режиме работы и временных уведомлений',
    ],
    planRequired: 'business',
  },

  // ── Аналитика ──
  {
    id: 'reports',
    path: '/reports',
    title: 'Отчёты',
    shortDesc: 'Аналитика и статистика: выручка, заказы, популярные товары, эффективность маркетинга, LTV клиентов.',
    fullDesc: 'Раздел отчётов предоставляет детальную аналитику по всем аспектам бизнеса. Графики, таблицы и ключевые метрики помогают принимать обоснованные решения.',
    features: [
      'Отчёт по выручке за период (графики и таблицы)',
      'Отчёт по заказам: количество, средний чек, конверсия',
      'Топ товаров по продажам и выручке',
      'Аналитика клиентов: LTV, частота, когорты',
      'Эффективность промокодов и акций',
      'Экспорт отчётов в CSV',
    ],
    tips: [
      'Еженедельно проверяйте отчёт по товарам для корректировки ассортимента',
      'Отслеживайте LTV клиентов для оценки эффективности маркетинга',
    ],
    planRequired: 'business',
  },

  // ── Управление ──
  {
    id: 'billing',
    path: '/billing',
    title: 'Подписка',
    shortDesc: 'Управление тарифным планом: текущий план, счета, история платежей, смена тарифа.',
    fullDesc: 'Управляйте подпиской на сервис. Просматривайте текущий тариф, доступные функции, историю платежей. Переход на более высокий план открывает доступ к дополнительным возможностям.',
    features: [
      'Просмотр текущего тарифного плана',
      'Список доступных функций по плану',
      'История платежей и счетов',
      'Смена тарифного плана',
      'Автоматическое продление подписки',
    ],
    tips: [
      'Сравните планы перед переходом — возможно, некоторые функции вам пока не нужны',
    ],
  },
  {
    id: 'settings-general',
    path: '/settings/general',
    title: 'Общие настройки',
    shortDesc: 'Основные данные заведения: название, SEO, ссылки на соцсети, юридическая информация.',
    fullDesc: 'Базовые настройки вашего заведения. Здесь указываются название, описание для SEO, ссылки на социальные сети, юридические данные и контактная информация.',
    features: [
      'Название и описание заведения',
      'SEO-настройки (title, description)',
      'Ссылки на социальные сети',
      'Юридическая информация (ИНН, ОГРН, адрес)',
      'Контактный телефон и email',
      'Логотип и favicon',
    ],
    tips: [
      'Заполните все SEO-поля для лучшей индексации в поисковых системах',
      'Укажите юридическую информацию для повышения доверия клиентов',
    ],
  },
  {
    id: 'settings-branches',
    path: '/settings/branches',
    title: 'Филиалы',
    shortDesc: 'Управление филиалами: адрес, координаты на карте, телефон, режим работы.',
    fullDesc: 'Если у вас несколько точек, настройте филиалы. Каждый филиал имеет свой адрес, координаты для отображения на карте, телефон и расписание работы.',
    features: [
      'Добавление нескольких филиалов',
      'Адрес и координаты на карте',
      'Контактный телефон филиала',
      'Режим работы (расписание по дням)',
      'Привязка зон доставки к филиалу',
    ],
    tips: [
      'Точно указывайте координаты — от них зависит расчёт доставки',
      'Обновляйте режим работы при изменениях (праздники, ремонт)',
    ],
  },
  {
    id: 'settings-order',
    path: '/settings/order',
    title: 'Настройки заказа',
    shortDesc: 'Конфигурация оформления заказа: обязательные поля, минимальная сумма, success-экран.',
    fullDesc: 'Настройте процесс оформления заказа под ваши нужды: какие поля обязательны, минимальная сумма заказа, текст на экране успешного оформления и другие параметры.',
    features: [
      'Минимальная сумма заказа',
      'Обязательные/необязательные поля (комментарий, подъезд, этаж)',
      'Текст на success-экране после оформления',
      'Настройка типов заказа (доставка / самовывоз)',
      'Время предзаказа',
    ],
    tips: [
      'Не делайте слишком много обязательных полей — это снижает конверсию',
      'Добавьте мотивирующий текст на success-экран',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-payment',
    path: '/settings/payment',
    title: 'Способы оплаты',
    shortDesc: 'Включение/выключение способов оплаты, ввод API-ключей платёжных провайдеров.',
    fullDesc: 'Настройте доступные способы оплаты для ваших клиентов. Подключите онлайн-оплату через платёжные провайдеры или оставьте только оплату при получении.',
    features: [
      'Оплата наличными при получении',
      'Оплата картой при получении',
      'Онлайн-оплата (ЮKassa, Тинькофф и др.)',
      'Ввод API-ключей провайдера',
      'Тестовый и боевой режим',
    ],
    tips: [
      'Обязательно протестируйте онлайн-оплату в тестовом режиме перед запуском',
      'Наличие онлайн-оплаты увеличивает конверсию на 10–15%',
    ],
    planRequired: 'starter',
  },
  {
    id: 'settings-delivery-zones',
    path: '/settings/delivery-zones',
    title: 'Зоны доставки',
    shortDesc: 'Полигоны зон доставки на карте: стоимость, минимальный заказ, время. Импорт из GeoJSON.',
    fullDesc: 'Задайте зоны доставки, рисуя полигоны на карте. Для каждой зоны настраивается стоимость доставки, минимальная сумма заказа и примерное время. Поддерживается импорт зон из GeoJSON.',
    features: [
      'Рисование полигонов зон на карте',
      'Стоимость доставки для каждой зоны',
      'Минимальная сумма заказа в зоне',
      'Примерное время доставки',
      'Бесплатная доставка от определённой суммы',
      'Импорт/экспорт зон в формате GeoJSON',
    ],
    tips: [
      'Создайте 2–3 зоны: ближнюю (дешёвая/бесплатная), среднюю и дальнюю',
      'Регулярно проверяйте покрытие зон при расширении географии',
    ],
    planRequired: 'starter',
  },
  {
    id: 'settings-design',
    path: '/settings/design',
    title: 'Дизайн',
    shortDesc: 'Кастомизация внешнего вида: цвета, шрифты, логотип, стиль карточек товаров.',
    fullDesc: 'Настройте внешний вид вашего сайта под фирменный стиль. Выбор цветовой палитры, шрифтов, загрузка логотипа и выбор стиля отображения карточек товаров.',
    features: [
      'Основной и акцентный цвета',
      'Выбор шрифтов',
      'Загрузка логотипа',
      'Стиль карточек товаров (варианты отображения)',
      'Предпросмотр изменений в реальном времени',
    ],
    tips: [
      'Используйте фирменные цвета для узнаваемости бренда',
      'Проверяйте читаемость текста на выбранном фоне',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-employees',
    path: '/settings/employees',
    title: 'Сотрудники',
    shortDesc: 'Управление администраторами: добавление, роли и права доступа к разделам панели.',
    fullDesc: 'Добавляйте сотрудников и назначайте им роли с различным уровнем доступа. Это позволяет безопасно делегировать работу с панелью.',
    features: [
      'Добавление администраторов по email',
      'Роли: владелец, администратор, менеджер, оператор',
      'Настройка доступа к разделам',
      'Блокировка и удаление сотрудников',
    ],
    tips: [
      'Давайте минимально необходимые права — это повышает безопасность',
      'Оператору достаточно доступа к заказам и клиентам',
    ],
  },
  {
    id: 'settings-import-export',
    path: '/settings/import-export',
    title: 'Импорт/Экспорт',
    shortDesc: 'Экспорт данных в CSV и импорт товаров из файла. Массовое обновление каталога.',
    fullDesc: 'Выгружайте заказы в CSV. Переносите каталог через мастер: экспорт в JSON, загрузка JSON или CSV по шаблону, сопоставление записей, предпросмотр и явное подтверждение. Пустые ячейки CSV не меняют поля.',
    features: [
      'Экспорт каталога в версионный JSON',
      'Экспорт заказов в CSV',
      'Импорт каталога из JSON или CSV по шаблону',
      'Явное сопоставление филиалов, дополнений и фотографий',
      'Предпросмотр и подтверждение изменений',
    ],
    tips: [
      'Скачайте шаблон CSV перед подготовкой файла импорта',
      'Перед массовым импортом сделайте резервную копию текущих данных',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-service-api',
    path: '/settings/service-api',
    title: 'Ключи API каталога',
    shortDesc: 'Доступ внешней системы к каталогу с явными правами и сроком действия.',
    fullDesc: 'Владелец или администратор выпускает ключ для выбранной компании. По умолчанию доступ только на чтение и только к явно выбранным филиалам. Доступ ко всей компании и бессрочный ключ требуют отдельных подтверждений. Секрет показывается один раз; после закрытия его можно только заменить новым ключом.',
    features: ['Чтение или изменение каталога', 'Ограничение по филиалам; запись только стоп-листа в выбранных филиалах', 'Срок действия и история последнего использования', 'Отзыв доступа без удаления истории'],
    tips: ['Передавайте ключ только в заголовке Authorization: Bearer, никогда в адресе страницы.', 'API каталога: /api/v1/service/catalog/products. Изменения проходят через changesets и отдельный apply.', 'При потере ответа о выпуске сначала обновите список и проверьте ключи. Секрет существующего ключа восстановить нельзя.'],
  },
  {
    id: 'settings-crm',
    path: '/settings/crm',
    title: 'CRM-интеграция',
    shortDesc: 'Подключение CRM-систем: Frontpad, iiko, R-Keeper. Маппинг статусов заказов и товаров.',
    fullDesc: 'Интеграция с популярными CRM-системами для автоматической передачи заказов. Настройте маппинг статусов и товаров для корректной синхронизации.',
    features: [
      'Подключение Frontpad',
      'Подключение iiko (планируется)',
      'Подключение R-Keeper (планируется)',
      'Маппинг статусов заказов',
      'Маппинг товаров и модификаторов',
      'Логи синхронизации и ошибок',
    ],
    tips: [
      'После подключения CRM проверьте маппинг всех товаров',
      'Мониторьте логи первые дни для выявления ошибок синхронизации',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-integrations',
    path: '/settings/integrations',
    title: 'Интеграции',
    shortDesc: 'Статус подключённых сервисов: аналитика, карты, уведомления, платёжные системы.',
    fullDesc: 'Обзор всех подключённых интеграций в одном месте. Проверяйте статус, управляйте API-ключами и подключайте новые сервисы.',
    features: [
      'Обзор статуса всех интеграций',
      'Yandex Метрика и Google Analytics',
      'Яндекс Карты для зон доставки',
      'Telegram-бот уведомлений',
      'SMS-провайдеры',
    ],
    tips: [
      'Подключите Яндекс Метрику для отслеживания поведения пользователей',
      'Настройте Telegram-уведомления для оперативного получения заказов',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-chatbots',
    path: '/settings/chatbots',
    title: 'Чат-боты',
    shortDesc: 'Подключение VK-ботов: Senler, TargetHunter. Автоматизация общения с клиентами в VK.',
    fullDesc: 'Настройте интеграцию с VK-ботами для автоматизации коммуникации с клиентами. Подключите Senler для рассылок или TargetHunter для чат-ботов.',
    features: [
      'Подключение бота Senler',
      'Подключение бота TargetHunter',
      'Настройка приветственного сообщения',
      'Автоматические ответы',
      'Статус подключения и тестирование',
    ],
    tips: [
      'Настройте приветственное сообщение с актуальным меню или акцией',
    ],
    planRequired: 'business',
  },
  {
    id: 'settings-vk-market',
    path: '/settings/vk-market',
    title: 'VK Market',
    shortDesc: 'Синхронизация товаров с VK Market: автоматическая выгрузка каталога в сообщество VK.',
    fullDesc: 'Автоматическая синхронизация вашего каталога товаров с разделом «Товары» в сообществе VK. Все изменения (цены, описания, изображения) синхронизируются автоматически.',
    features: [
      'Автоматическая выгрузка товаров в VK Market',
      'Синхронизация цен и описаний',
      'Синхронизация изображений',
      'Выбор категорий для выгрузки',
      'Логи синхронизации',
    ],
    tips: [
      'Выгружайте только актуальные товары с качественными изображениями',
      'Проверьте, что сообщество VK настроено как «Магазин»',
    ],
    planRequired: 'business',
  },
    {
    id: 'crm-import',
    path: '/crm-import',
    title: 'Товары из CRM',
    shortDesc: 'Импорт товаров из CRM-системы (Frontpad, iiko, Poster и др.) в каталог. Выбор товаров, привязка к разделам.',
    fullDesc: 'Загрузите список товаров из подключённой CRM-системы, выберите нужные и сохраните их в каталог вашего сайта. Товары привязываются по артикулу — это обеспечивает корректную передачу заказов обратно в CRM и синхронизацию стоп-листа.',
    features: [
      'Загрузка товаров из CRM одной кнопкой',
      'Таблица с артикулами, названиями и ценами',
      'Отметка уже импортированных товаров',
      'Фильтрация: все / новые / импортированные',
      'Поиск по названию или артикулу',
      'Выбор раздела каталога для импорта',
      'Выбор параметров для сохранения (название, цена)',
      'Массовый импорт выбранных товаров',
      'Поддержка всех CRM: Frontpad, iiko, Poster, R-Keeper, СБИС, YumaPOS, Goulash',
    ],
    tips: [
      'Frontpad: лимит 1 запрос в час на загрузку списка товаров — планируйте заранее',
      'Убедитесь, что товарам в CRM присвоены уникальные цифровые артикулы',
      'После импорта проверьте привязку товаров — артикулы должны совпадать',
      'Создайте разделы каталога заранее, чтобы импортировать товары сразу в нужные категории',
      'Уже импортированные товары пропускаются автоматически — повторный импорт безопасен',
    ],
    planRequired: 'business',
  },
];

// Группировка секций по категориям — ID берутся из pageRegistry.ts
import { getHelpIds } from '../../pageRegistry';

export const helpCategories: HelpCategory[] = [
  {
    title: 'Основное',
    items: helpSections.filter((s) => getHelpIds('basic').includes(s.id)),
  },
  {
    title: 'Маркетинг',
    items: helpSections.filter((s) => getHelpIds('marketing').includes(s.id)),
  },
  {
    title: 'Контент',
    items: helpSections.filter((s) => getHelpIds('content').includes(s.id)),
  },
  {
    title: 'Аналитика',
    items: helpSections.filter((s) => getHelpIds('analytics').includes(s.id)),
  },
  {
    title: 'Управление',
    items: helpSections.filter((s) => getHelpIds('management').includes(s.id)),
  }];

// Группировка гайдов быстрого старта
export const quickStartItems = helpSections.filter((s) =>
  ['quick-start-overview', 'quick-start-telegram', 'quick-start-vk', 'quick-start-first-order'].includes(s.id)
);

// Поиск раздела справки по текущему пути
export function getHelpByPath(path: string): HelpItem | undefined {
  // Удаляем /admin префикс если есть
  const cleanPath = path.replace(/^\/admin/, '') || '/';
  return helpSections.find((s) => s.path === cleanPath);
}
